export function getMiddleInitials(middleName?: string): string {
  if (!middleName) return '';

  // Normalize whitespace and trim
  const cleaned = middleName.trim();
  if (!cleaned) return '';

  // Split on spaces or hyphens
  const parts = cleaned.split(/[\s-]+/);

  // Extract the first letter of each part
  const initials = parts
    .filter((p) => p.length > 0)
    .map((p) => p.charAt(0).toUpperCase())
    .join('');

  return initials;
}
